import React from "react";
import { Icon, RaiseColors } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var LoadingContainer = function LoadingContainer(_ref) {
  var _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 48 : _ref$iconSize,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? RaiseColors.glacier2400 : _ref$iconColor,
    _ref$customHeight = _ref.customHeight,
    customHeight = _ref$customHeight === void 0 ? "80vh" : _ref$customHeight,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? "25vh" : _ref$paddingTop;
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: "100%",
      textAlign: "center",
      height: customHeight,
      paddingTop: paddingTop
    },
    children: /*#__PURE__*/_jsx(Icon, {
      fontSize: iconSize,
      color: iconColor,
      className: "fal fa-spin fa-spinner",
      "data-testid": "loadingContainerIcon"
    })
  });
};
export default LoadingContainer;